import { render, staticRenderFns } from "./dashboardrepair0308.vue?vue&type=template&id=f351e7dc&scoped=true&"
import script from "./dashboardrepair0308.vue?vue&type=script&lang=js&"
export * from "./dashboardrepair0308.vue?vue&type=script&lang=js&"
import style0 from "./dashboardrepair0308.vue?vue&type=style&index=0&id=f351e7dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f351e7dc",
  null
  
)

export default component.exports